/** Chance the lead will sign — RYG on CRM. New leads default to red. */

export const SIGNING_CHANCE_VALUES = ['red', 'yellow', 'green'];

export const SIGNING_CHANCE_META = {
  red: { label: 'Low', dotColor: '#EF4444' },
  yellow: { label: 'Medium', dotColor: '#CA8A04' },
  green: { label: 'High', dotColor: '#16A34A' },
};

/**
 * @param {object} [lead]
 * @returns {'red'|'yellow'|'green'}
 */
export function normalizeLeadSigningChance(lead) {
  const sc = lead?.signingChance;
  if (sc === 'yellow' || sc === 'green' || sc === 'red') return sc;
  const n = typeof lead?.score === 'number' ? lead.score : NaN;
  if (!Number.isNaN(n) && n > 0) {
    if (n >= 8) return 'green';
    if (n >= 4) return 'yellow';
  }
  return 'red';
}
